export default "__VITE_ASSET__CVg_mY5I__"